export function replaceWhiteLabelTitle({ title = '', isWhiteLabel = false }) {
    if (!isWhiteLabel) return title;
    return title.replace(/( - PatSnap)$|( - 智慧芽)$|( - Eureka)$/i, '');
}
